import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ConfigService } from '../configHelper';

@Injectable({
   providedIn: 'root'
})
export class ShipmentDataService {

   constructor(private httpClient: HttpClient, private configService: ConfigService) {
   }

   public getList(start, count, sortBy, sortDirection, filters) {
      let url: string = `${this.configService.getConfig().apiURL}v1/Internal/Shipment/GetList?start=${start}&length=${count}&sortBy=${sortBy}&sortDirection=${sortDirection}&filters=${JSON.stringify(filters)}`;
      return this.httpClient.get(url);
   }

   public getFilters() {
      let url: string = `${this.configService.getConfig().apiURL}v1/Internal/Shipment/GetFilters`;
      return this.httpClient.get(url);
   }

   public getPackageByTrackingNumber(trackingId) {
     var url: string;
     url = `${this.configService.getConfig().apiURL}v1/Internal/Shipment/GetByTrackingNumber?trackingNumber=${trackingId}`;
     return this.httpClient.get(url);
   }
}
